import { getCutoffTime } from '@src/quince-site-common/src/hooks/edd/utils/edd.utils'
import { useTranslation } from 'next-i18next'
import React from 'react'

import styles from './orderCutoffTime.module.scss'

interface Props {
  cutoffDate: number
}

const OrderCutoffTime = (props: Props) => {
  const { cutoffDate } = props
  const { t } = useTranslation('common', { keyPrefix: 'edd' })

  const label = getCutoffTime(cutoffDate, t)

  if (!label) {
    return null
  }

  return <div className={styles.orderCutoffTime}>{label}</div>
}

export default OrderCutoffTime
